export default __webpack_public_path__ + "static/media/part.8b69244d.svg";